<template>
    <span v-if="availability"
        :class="classes"
        :style="paddingStyles"
        :data-bx-item-id="'availability='+availability.id">
        <span>
            {{ name }}
        </span>
    </span>
</template>

<script>
export default {
    name: "item-availability",

    props: {
        paddingClasses: String,
        paddingStyles: String
    },

    inject: {
        itemId: {
            default: null
        }
    },

    computed:
    {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`];
        },

        availability() {
            return this.currentVariation && this.currentVariation.variation && this.currentVariation.variation.availability;
        },

        classes() {
            let availabilityClasses = [
                "availability",
                "badge",
                this.paddingClasses,
                "rounded-pill",
                "w-100",
                "bx-narrative-item",
                "bx-narrative-root-item"
            ];
            if ((this.availability.id === 2 && this.currentVariation.stock.net > 0) || this.availability.id === 1) {
                availabilityClasses.push("badge-secondary");
            }
            else {
                availabilityClasses.push("badge-primary");
            }
            return availabilityClasses;
        },

        name() {
            let text = this.availability && this.availability.names && this.availability.names.name;
            if (this.availability.id === 2 && this.currentVariation.stock.net > 0) {
                text = "Sofort verfügbar";
            }
            else if (this.currentVariation.variation.releasedAt) {
                const today = new Date().getTime();
                const releaseDate = new Date(this.currentVariation.variation.releasedAt).getTime();
                const sanktNimmerlein = new Date(2030,11,31);
                if (releaseDate - today > 0) {
                    if (Math.abs(sanktNimmerlein - releaseDate) < 86400000) {
                        text = "Liefertermin unbekannt";
                    } else {
                      text = "Voraussichtlich verfügbar ab " + Vue.filter("date").apply(null, [this.currentVariation.variation.releasedAt, "DD.MM.YYYY"]);
                    }
                }
            }
          return text;
        }
    }
}
</script>
